import React from 'react';

export const ArrowRightDiagonal = ({ color = 'white' }: { color?: string }) => (
  <svg width="18" height="18" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 2.16667V2.83333H5.19667L1.33333 6.69667L1.80333 7.16667L5.66667 3.30333V5.5H6.33333V2.16667H3Z"
          fill={color} />
  </svg>
);
